import { Container } from '~/components/Main/GroupChatSection/GroupChatItem/GroupChatItem.styled';

export default function GroupChatCard() {
  return <Container />;
}
